import type { ReactNode } from 'react'
import './EmbeddedShell.css'

/**
 * The layout for the embeddable `/p/*` route tree — the counterpart to the full app's AppShell.
 * It fills the iframe viewport with a chrome-free, scrollable surface (no sidebar, no masthead)
 * and renders the same page components the full app uses. Pages that manage their own internal
 * scroll (e.g. ProjectDetail's tab sheet) fill it via `flex: 1`; normal-flow pages scroll the
 * shell itself.
 */
export default function EmbeddedShell({ children }: { children: ReactNode }) {
  return (
    <div className="embedded-shell" data-testid="embedded-shell">
      {children}
    </div>
  )
}
